import React from 'react';
import './style.scss';
import { PriceInput, PriceInputProps } from 'views/mutual/priceInput';
import { formatPrice } from 'views/utils/converter';
import { multiplyNullable } from '../../calculation';
import { FontSize } from '../../enums';
import { LotInputCommonDescriptions } from '../common';

type ApplyLotInputProps = {
  title: string;
  realEstateBeneficiaryRightPrice: number | null;
  realEstatePriceEquivalent: number | null;
  consumptionTaxAmount: number | null;
  repairReserveFundEquivalent: number | null;
  requiredWorkingCapitalReserveEquivalent: number | null;
  priceInputProps?: PriceInputProps;
};

type ApplySymbolOverviewRowProps = {
  label: string;
  value: string;
  unit?: string;
  comment?: string;
  size?: (typeof FontSize)[keyof typeof FontSize];
};

const ApplySymbolOverviewRow = ({ label, value, unit, comment, size }: ApplySymbolOverviewRowProps) => (
  <div className={`applySymbolOverviewRow ${size ?? ''}`.trim()}>
    <div className="applySymbolOverviewRow_label">{label}</div>
    <div className="applySymbolOverviewRow_value-unit">
      <span>{value}</span>
      {unit && <span>{unit}</span>}
    </div>
    {comment && <div className="applySymbolOverviewRow_comment">{comment}</div>}
  </div>
);

export const ApplyLotInputBody = (props: ApplyLotInputProps) => (
  <div className="lotInput">
    <div className="lotInput_header">{props.title}</div>
    <div className="lotInput_body">
      <div className="overview">
        <div className="overview_priceInput">
          <PriceInput {...props.priceInputProps!} />
          <span>{'個'}</span>
        </div>
        <div className="overview_purchaseDetails-total">
          <ApplySymbolOverviewRow
            label="不動産受益権価格"
            value={formatPrice(multiplyNullable(props.realEstateBeneficiaryRightPrice, props.priceInputProps?.price ?? null))}
            unit="円"
            size={FontSize.medium}
          />
        </div>
        <div className="overview_purchaseDetails">
          <ApplySymbolOverviewRow
            label={`（内訳）不動産価格相当額\n（うち消費税等${formatPrice(
              multiplyNullable(props.consumptionTaxAmount, props.priceInputProps?.price ?? null),
            )}円）`}
            value={formatPrice(multiplyNullable(props.realEstatePriceEquivalent, props.priceInputProps?.price ?? null))}
            unit="円"
            size={FontSize.small}
          />
          <ApplySymbolOverviewRow
            label="修繕積立金相当額"
            value={formatPrice(multiplyNullable(props.repairReserveFundEquivalent, props.priceInputProps?.price ?? null))}
            unit="円"
            size={FontSize.small}
          />
          <ApplySymbolOverviewRow
            label="必要運転資金留保金相当額"
            value={formatPrice(multiplyNullable(props.requiredWorkingCapitalReserveEquivalent, props.priceInputProps?.price ?? null))}
            unit="円"
            size={FontSize.small}
          />
        </div>
      </div>
      <LotInputCommonDescriptions />
    </div>
  </div>
);
